import { Injectable } from '@angular/core';

import { TmsWebBaseCommentService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderCommentService extends TmsWebBaseCommentService {
  constructor() {
    super('PurchaseOrderComment');
  }
}
